import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { PartialRouteObject } from 'react-router';

import BaseLayout from 'src/layouts/BaseLayout';

import SuspenseLoader from 'src/components/SuspenseLoader';
import AccountSettings from './content/pages/Setting';
import AccountSettingsS3 from './content/pages/Setting';
import ProtectedRoute, { SessionMaintained } from './components/ProtectedRoute';
import { AmacUrl, Page } from './common/routes';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

//Static Page
const Home = Loader(lazy(() => import('src/content/pages/Home')));
const AboutUs = Loader(lazy(() => import('src/content/pages/About-Us')));
const HowItWorks = Loader(lazy(() => import('src/content/pages/How-It-Works')));
const PilotProgram = Loader(
  lazy(() => import('src/content/pages/Pilot-Program'))
);
const Solutions = Loader(lazy(() => import('src/content/pages/Solutions')));
const TermsAndConditions = Loader(lazy(() => import('src/content/pages/Terms-And-Conditions')));
const PrivacyPolicy = Loader(lazy(() => import('src/content/pages/Privacy-Policy')));
const ContactUs = Loader(lazy(() => import('src/content/pages/Contact-Us')));


//Pages
const Status404 = Loader(
  lazy(() => import('src/content/pages/Status/Status404'))
);
const Status500 = Loader(
  lazy(() => import('src/content/pages/Status/Status500'))
);
const StatusComingSoon = Loader(
  lazy(() => import('src/content/pages/Status/ComingSoon'))
);
const StatusMaintenance = Loader(
  lazy(() => import('src/content/pages/Status/Maintenance'))
);

const routes: PartialRouteObject[] = [
  {
    path: '/',
    element: (
      <SessionMaintained>
        <BaseLayout />
      </SessionMaintained>
    ),
    children: [
      {
        path: `${Page.Home}`,
        element: <Home />
      },
      {
        path: `${Page.AboutUs}`,
        element: <AboutUs />
      },
      {
        path: `${Page.HowItWorks}`,
        element: <HowItWorks />
      },
      {
        path: `${Page.PilotProgram}`,
        element: <PilotProgram />
      },
      {
        path: `${Page.Solutions}`,
        element: <Solutions />
      },
      {
        path: `${Page.TermsAndConditions}`,
        element: <TermsAndConditions />
      },
      {
        path: `${Page.PrivacyPolicy}`,
        element: <PrivacyPolicy />
      },
      {
        path: `${Page.ContactUs}`,
        element: <ContactUs />
      }
      // {
      //   path: Page.VoterTurnout,
      //   element: <VoterTurnout />
      // },
      // {
      //   path: Page.VoterPopulation,
      //   element: <VoterPopulation />
      // }
    ]
  },
  {
    path: '*',
    element: (
      <SessionMaintained>
        <BaseLayout />
      </SessionMaintained>
    ),
    children: [
      // {
      //   path: Page.MFACode,
      //   element: <MFACode />
      // },
      {
        path: 'status',
        children: [
          {
            path: '/',
            element: <Navigate to="404" replace />
          },
          {
            path: '404',
            element: <Status404 />
          },
          {
            path: '500',
            element: <Status500 />
          },
          {
            path: 'maintenance',
            element: <StatusMaintenance />
          },
          {
            path: 'coming-soon',
            element: <StatusComingSoon />
          }
        ]
      },
      {
        path: '*',
        element: <Status404 />
      }
    ]
  }
];

export default routes;
